export default "__VITE_ASSET__c567a965__"